(function($) {

/*
*  new_map
*
*  This function will render a Google Map onto the selected jQuery element
*
*  @type	function
*  @date	8/11/2013
*  @since	4.3.0
*
*  @param	$el (jQuery element)
*  @return	n/a
*/

function new_map( $el ) {

	// var
	var $markers = $el.find('.marker');


	// vars
	var args = {
		zoom		: 6,
		center		: new google.maps.LatLng(51.91943, 19.145136),
		mapTypeId	: google.maps.MapTypeId.ROADMAP
	};


	// create map
	var map = new google.maps.Map( $el[0], args);


	// add a markers reference
	map.markers = [];


	// add markers
	$markers.each(function(){

    	add_marker( $(this), map );

	});

	// return
	return map;

}

/*
*  add_marker
*
*  This function will add a marker to the selected Google Map
*
*  @type	function
*  @date	8/11/2013
*  @since	4.3.0
*
*  @param	$marker (jQuery element)
*  @param	map (Google Map object)
*  @return	n/a
*/

function hideAllInfoWindows(map) {
    map.markers.forEach(function(marker) {
        marker.infowindow.close(map, marker);
    });
}

function add_marker( marker_data, map ) {

	// var
	var latlng = new google.maps.LatLng( marker_data.lat, marker_data.lng );

	// create marker
	var marker = new google.maps.Marker({
		position	: latlng,
		map			: map,
	});

    var icon_url = marker_data.icon;

    if (icon_url !== undefined ) {
        marker.setIcon(acfmaps.imgdir + icon_url + "-small.png");
    }

	// add to array
	map.markers.push( marker );

	// if marker contains HTML, add it to an infoWindow
	if( marker_data.content )
	{
		// create info window
		var infowindow = new google.maps.InfoWindow({
			content		: marker_data.content,
            maxWidth    : 325
		});

        marker.infowindow = infowindow;

		// show info window when marker is clicked
		google.maps.event.addListener(marker, 'click', function() {

            hideAllInfoWindows(map);
			infowindow.open( map, marker );

		});

        google.maps.event.addListener(infowindow, 'domready', function() {

            // Reference to the DIV which receives the contents of the infowindow using jQuery
            var iwOuter = $('.gm-style-iw');

            /* The DIV we want to change is above the .gm-style-iw DIV.
                * So, we use jQuery and create a iwBackground variable,
                * and took advantage of the existing reference to .gm-style-iw for the previous DIV with .prev().
                */
            var iwBackground = iwOuter.prev();

            // Remove the background shadow DIV
            iwBackground.children(':nth-child(2)').css({'display' : 'none'});

            // Remove the white background DIV
            iwBackground.children(':nth-child(4)').css({'display' : 'none'});

            var iwCloseBtn = iwOuter.next();

            iwCloseBtn.addClass("gm-style-close");

            var iwContainer = iwOuter.parent();
            iwContainer.addClass("gm-style-iw-container");

            // The API automatically applies 0.7 opacity to the button after the mouseout event.
            // This function reverses this event to the desired value.
            iwCloseBtn.mouseout(function(){
                $(this).css({opacity: '1'});
            });

        });
	}

}

/*
*  center_map
*
*  This function will center the map, showing all markers attached to this map
*
*  @type	function
*  @date	8/11/2013
*  @since	4.3.0
*
*  @param	map (Google Map object)
*  @return	n/a
*/

function center_map( map ) {

	// vars
	var bounds = new google.maps.LatLngBounds();

	// loop through all markers and create bounds
	$.each( map.markers, function( i, marker ){

		var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

		bounds.extend( latlng );

	});

	// only 1 marker?
	if( map.markers.length == 1 )
	{
		// set center of map
	    map.setCenter( bounds.getCenter() );
	    map.setZoom( 16 );
	}
	else
	{
		// fit to bounds
		map.fitBounds( bounds );
	}

}

function update_address() {
    var place = autocomplete_addr.getPlace();

    if (place === undefined || !place.geometry) {
        return;
    }

    $("input#map-location").val(place.address_components[0].long_name);
}

function show_place_by_address() {
    var address = $("input#map-location").val();
    var geocoder = new google.maps.Geocoder();
    geocoder.geocode({'address': address}, function(results, status) {
        if(status == google.maps.GeocoderStatus.OK) {
            if(results[0]) {
                var location = results[0].geometry.location;

                if (cityCircle !== null) {
                    remove_circle(cityCircle);
                }

                if (circleRadius > 0) {
                    add_circle(location, circleRadius);
                    var bounds = cityCircle.getBounds();
                    map.fitBounds(bounds);
                    mapCenter = cityCircle.getCenter();
                } else {
                    map.setCenter(location);
                    map.setZoom(10);
                }
                update_markers();
                display_places();
            } else {
                //alert("No results found");
            }
        } else {
            //alert("Geocoder failed due to: " + status);
        }
    });

}

function set_address_from_coords(lat, lng) {
    var latlng = new google.maps.LatLng(lat, lng);
    var geocoder = new google.maps.Geocoder();
    geocoder.geocode({'latLng': latlng}, function(results, status) {
        if(status == google.maps.GeocoderStatus.OK) {
            if(results[1]) {
                //formatted address
                //var address = results[1].address_components[0].long_name;
                var address = results[1].formatted_address;
                $("#map-location").val(address);
            } else {
                //alert("No results found");
            }
        } else {
            alert("Geocoder failed due to: " + status);
        }
    });
}


function map_geolocate() {
    // Try HTML5 geolocation.
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function(position) {
            var pos = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
            };

            set_address_from_coords(position.coords.latitude, position.coords.longitude);
            show_place_by_address();
        }, function() {
        });
    } else {
        // Browser doesn't support Geolocation
    }
}

function add_circle(location, radius) {
    cityCircle = new google.maps.Circle({
      strokeWeight: 0,
      fillColor: '#0b95e5',
      fillOpacity: 0.3,
      map: map,
      center: location,
      radius: radius,
      editable: true
    });

    google.maps.event.addListener(cityCircle, 'center_changed', function() {
        mapCenter = cityCircle.getCenter();
        display_places();
        update_markers();
    });

    google.maps.event.addListener(cityCircle, 'radius_changed', function() {
        circleRadius = cityCircle.getRadius();
        display_places();
        update_markers();
    });
}

function remove_circle(circle) {
    // remove event listers
    google.maps.event.clearListeners(circle, 'center_changed');
    google.maps.event.clearListeners(circle, 'radius_changed');
    circle.setRadius(0);
    // if polygon:
    // polygon_shape.setPath([]);
    circle.setMap(null);
}

function display_places(paged) {
    if (paged === undefined) {
        paged = null;
    }

    var categories = get_categories("");

    var ajax_data = {
        action: "places_search",
        categories: categories,
        paged: paged,
    };

    if (mapCenter !== null) {
        ajax_data["lat"] = mapCenter.lat;
        ajax_data["lng"] = mapCenter.lng;
    }

    if (circleRadius === null) {
        circleRadius = parseInt($("select#map-radius").val()) * 1000;
    }

    ajax_data["radius"] = circleRadius;

    $.ajax({
        type: "POST",
        dataType: "html",
        url: acfmaps.ajaxurl,
        data: ajax_data,
        success: function(data){
            $(".ajax-posts").html(data);
            Foundation.reInit('equalizer');
            //$(".ajax-posts")[0].scrollIntoView();
        }

    });
}

function radius_changed(event) {
    event.preventDefault();
    circleRadius = parseInt($("select#map-radius").val()) * 1000;
    show_place_by_address();
}

function map_search(event) {
    event.preventDefault();

    if (circleRadius === null) {
        circleRadius = parseInt($("select#map-radius").val()) * 1000;
    }

    show_place_by_address();
}

function get_categories(prefix) {
    if (prefix === undefined) {
        prefix = "cat-";
    }

    var mapCategories = [];
    $(".map__category-container .checkbox-list input").each(function() {
        if ($(this).attr("checked")) {
            mapCategories.push(prefix + $(this).val());
        }
    });
    return mapCategories;
}

function delete_markers(map) {
    for (var i = 0; i < map.markers.length; i++) {
        map.markers[i].setMap(null);
    }
    map.markers = [];
}

function update_markers() {
    var categories = get_categories("");
    var ajax_data = { action: "place_markers",
        categories: categories
    };

    if (mapCenter !== null) {
        ajax_data["lat"] = mapCenter.lat;
        ajax_data["lng"] = mapCenter.lng;
    }

    if (circleRadius !== null) {
        ajax_data["radius"] = circleRadius;
    }

    $.ajax({
        type: "POST",
        dataType: "json",
        url: acfmaps.ajaxurl,
        data: ajax_data,
        success: function(data){
            delete_markers(map);

            for (var i = 0; i < data.length; i++) {
                add_marker(data[i], map);
            }
        }

    });
}

function filter_changed() {
    if (circleRadius === null) {
        circleRadius = parseInt($("select#map-radius").val()) * 1000;
    }

    update_markers();
    display_places();
}

function address_changed() {
    update_address();

    if (circleRadius === null) {
        circleRadius = parseInt($("select#map-radius").val()) * 1000;
    }

    show_place_by_address();
}

/*
*  document ready
*
*  This function will render each map when the document is ready (page has loaded)
*
*  @type	function
*  @date	8/11/2013
*  @since	5.0.0
*
*  @param	n/a
*  @return	n/a
*/
// global var
var map = null;
var autocomplete_addr = null;
var cityCircle = null;
var mapCenter = null;
var circleRadius = null;

$(document).ready(function(){

	$('.acf-map').each(function(){

		// create map
		map = new_map( $(this) );

	});

    $("a.map__geoloc").click(map_geolocate);

    var autocomplete_opts = {
        componentRestrictions: {country: 'pl'},
        types: ['(cities)']
    };
    var input_addr = document.getElementById('map-location');
    autocomplete_addr = new google.maps.places.Autocomplete(input_addr, autocomplete_opts);
    autocomplete_addr.addListener('place_changed', address_changed);

    $("#map-btn").click( map_search );
    $("#map-radius").change( radius_changed );
    //$("#map-location").change( map_search );
    $(".map__category-container .checkbox-list input").change( filter_changed );
    /*$(".map__category-container .checkbox-list li::before").click(function() {
        $(this).find( "input[type='checkbox']" ).prop( "checked", function( i, val ) {
            return !val;
        });
    });*/

    $(".ajax-posts").on("click", ".page-navigation > .pagination > li > a", function(event) {
        event.preventDefault();
        display_places($(this).data("paged"));
        return false;
    });

    $('.tabs').on('change.zf.tabs', function(e, tgt){
        Foundation.reInit('equalizer');
    });

    $(window).resize(function() {
        google.maps.event.trigger(map, "resize");
    });

    update_markers();
    display_places();
});

})(jQuery);
